module.exports = __webpack_public_path__ + "img/step3-detail_top2.326315ae.png";